import { useTranslation } from 'module/hooks/use-translation';
import { Dialog, InputField } from '@rocketlane/ui';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

const Body = styled.div`
  margin-top: var(--spacing-03);
`;

type TemplateNameConflictModalProps = {
  open: boolean;
  name: string;
  errorMessage?: string;
  isSubmitting: boolean;
  onNameChange: (value: string) => void;
  onCancel: () => void;
  onSave: () => void;
};

export const TemplateNameConflictModal = ({
  open,
  name,
  errorMessage,
  isSubmitting,
  onNameChange,
  onCancel,
  onSave,
}: TemplateNameConflictModalProps) => {
  const placeholder = useTranslation('template_name_conflict.placeholder');
  const canSave = name.trim().length > 0 && !isSubmitting;

  return (
    <Dialog
      open={open}
      onCancel={onCancel}
      onAction={onSave}
      title={<FormattedMessage id="template_name_conflict.title" />}
      cancelProps={{
        disabled: isSubmitting,
        text: <FormattedMessage id="cancel" />,
      }}
      actionProps={{
        disabled: !canSave,
        loading: isSubmitting,
        text: <FormattedMessage id="save" />,
      }}
      width={480}
      content={
        <Body>
          <InputField
            value={name}
            onChange={(e) => onNameChange(e.target.value)}
            placeholder={placeholder}
            helperText={errorMessage}
            helperTextType="error"
            onPressEnter={() => {
              if (canSave) {
                onSave();
              }
            }}
            autoFocus
          />
        </Body>
      }
    />
  );
};
